import { useDispatch, useSelector } from "react-redux";

import { IRootState } from "../../../state";
import { appointmentUserRatingActions } from "../../../state/booked-appoinments-rating";

const useAppointmentRatingStore = () => {
  const dispatch = useDispatch();

  const userRating = useSelector((state: IRootState) => state.appointmentUserRating);

  const setAppointmentStarRating = (data: any) => {
    dispatch(appointmentUserRatingActions.setAppointmentsStarRating(data));
  };

  const setAppointmentStepOneFeedback = (data: string | null) => {
    dispatch(appointmentUserRatingActions.setAppointmentStepOneFeedback(data));
  };


  const setAppointmentRatingNull = () => {
    dispatch(appointmentUserRatingActions.setAppointmentRatingNull());
  };

  return {
    setAppointmentStarRating,
    setAppointmentRatingNull,
    setAppointmentStepOneFeedback,
    userRating,
  };
};

export default useAppointmentRatingStore;
